// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

// We are serving the SPA from sub-path /ui-helper in the Main Service
// so need to set basename.
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/ui-helper">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

window.addEventListener("contextmenu", (e) => {
  e.preventDefault();
});
